module.exports = __webpack_public_path__ + "img/payment_process_yes.42562b4.png";